import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { A11yModule } from '@angular/cdk/a11y';
import { DialogService } from './dialog.service';
import { DialogContainerComponent } from './dialog-container.component';
import { DialogTitleDirective } from './dialog-title.directive';
import { DialogContentDirective } from './dialog-content.directive';
import { DialogActionsDirective } from './dialog-actions.directive';
import { DialogCloseDirective } from './dialog-close.directive';

@NgModule({
  imports: [OverlayModule, PortalModule, A11yModule],
  declarations: [
    DialogContainerComponent,
    DialogTitleDirective,
    DialogContentDirective,
    DialogActionsDirective,
    DialogCloseDirective,
  ],
  exports: [
    DialogTitleDirective,
    DialogContentDirective,
    DialogActionsDirective,
    DialogCloseDirective,
  ],
  providers: [DialogService],
})
export class DialogModule {}
